module.exports = __webpack_public_path__ + "static/media/ybfMeta.443bbf2e.png";